// The intro screen shown between picking a question and the question itself.
// A mode holds the default (mode.questionIntro); a question can follow it,
// replace it with its own, or switch it off (question.intro.use).
// Returns { text, image } or null when there is nothing to show.
export const resolveQuestionIntro = (question, mode) => {
  const own = question?.intro;
  if (own?.use === "off") return null;

  const source =
    own?.use === "custom"
      ? own
      : mode?.questionIntro?.enabled
      ? mode.questionIntro
      : null;
  if (!source) return null;

  const text = (source.text || "").trim();
  const image = source.image || "";
  return text || image ? { text, image } : null;
};
